import React, { useEffect, useState } from "react";
import styled from "styled-components";

import Content from "../components/content";
import Loader from "../components/loader";

import { useImpersonation } from "../global/impersonation";
import Helper from "../libs/helper";
import DownloadIcon from "@mui/icons-material/Download";
import { Menu, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import BasicTitle from "../components/title";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import Stack from "@mui/material/Stack";
import { Autocomplete } from "@mui/material";
import Modal from "@mui/material/Modal";

import { DataGrid, GridToolbarContainer } from "@mui/x-data-grid";

import Api from "../libs/api";
import Storage from "../libs/storage";
import ErrorModal from "../components/error_modal";

const Holder = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    overflow: auto;
`;

const Filters = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 32px;
`;

const AddCredit = styled.div`
    width: 100%;
    display: flex;
    align-items: left;
    /* justify-content: space-between; */
    margin-bottom: 32px;
`;

const LeftFilters = styled.div`
    min-width: 100px;
    display: flex;
    align-items: center;
`;

const Data = styled.div`
    margin-bottom: 100px;
`;

const ModalCenter = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    max-width: 688px;
    background-color: #ffffff;
    padding: 40px;
    border-radius: 8px;
    border: 1px solid rgb(144, 144, 144);
    -webkit-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
`;

const ModalClose = styled.img`
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
`;

const ErrorMessage = styled.p`
    color: red;
    padding-left: 15px;
    padding-bottom: 15px;
    font-size: 13px;
`;

const ModalRejector = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 430px;
    height: 380px;
    background-color: #ffffff;
    border-radius: 8px;
    border: 1px solid rgb(144, 144, 144);
    -webkit-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
`;

// const Tag = styled.div`
//     font-family: "Montserrat";
//     font-style: normal;
//     font-weight: 500;
//     font-size: 12px;
//     line-height: 12px;
//     text-align: center;
//     text-transform: capitalize;
//     padding: 4px 10px;
//     border-radius: 8px;

//     &.pendente {
//         color: #181122;
//         border: 1px solid #181122;
//     }
//     &.aprovado {
//         color: #57c4c2;
//         border: 1px solid #57c4c2;
//     }
//     &.rejeitado {
//         color: #de6061;
//         border: 1px solid #de6061;
//     }
//     &.pago {
//         color: #57c4c2;
//         border: 1px solid #57c4c2;
//     }
// `;

export default function Credits() {
    let api = Api();
    let storage = Storage();
    let helper = Helper();
    const { impersonateCompanyId } = useImpersonation();
    const API_URL = process.env.REACT_APP_API_URL;

    const [usersRows, setUsersRows] = useState([
        {
            id: 0,
            name: "---",
            credit: "---",
            disabled: "---",
        },
    ]);
    const [errorModalOpen, setErrorModalOpen] = useState(false);
    const [errorModalMessage, setErrorModalMessage] = useState("");

    function showErrorModal(message) {
        setErrorModalMessage(message);
        setErrorModalOpen(true);
    }

    const exportToCSV = async () => {
        try {
            const url = `${API_URL}/reports/users/credits/csv/`;
            const data = await storage.getItem("data");

            const options = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: data.token,
                },
            };

            if (impersonateCompanyId) {
                options.headers.Impersonate = impersonateCompanyId;
            }

            const response = await fetch(url, options);

            if (!response.ok) {
                if (response.status === 400) {
                    const errorMessage = await response.text();
                    throw new Error(errorMessage);
                }

                throw new Error(
                    "Não foi possível gerar o csv. \nTente novamente mais tarde."
                );
            }

            const blob = await response.blob();
            const fileURL = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = fileURL;
            a.download = "zag_usuarios_creditos.csv";
            a.click();
            window.URL.revokeObjectURL(fileURL);
        } catch (error) {
            showErrorModal(
                error.message ||
                    "Não foi possível gerar o csv. \nTente novamente mais tarde."
            );
        }
    };

    const exportToPDF = async () => {
        try {
            const url = `${API_URL}/reports/users/credits/pdf/`;
            const data = await storage.getItem("data");

            const options = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: data.token,
                },
            };

            if (impersonateCompanyId) {
                options.headers.Impersonate = impersonateCompanyId;
            }

            const response = await fetch(url, options);

            if (!response.ok) {
                if (response.status === 400) {
                    const errorMessage = await response.text();
                    throw new Error(errorMessage);
                }

                throw new Error(
                    "Erro ao gerar PDF. \nTente novamente mais tarde."
                );
            }

            const blob = await response.blob();
            const fileURL = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = fileURL;
            a.download = "zag_usuarios_creditos.pdf";
            a.click();
            window.URL.revokeObjectURL(fileURL);
        } catch (error) {
            showErrorModal(
                error.message ||
                    "Erro ao gerar PDF. \nTente novamente mais tarde."
            );
        }
    };

    const getStartAndEndDates = () => {
        let start, end;

        if (startDay !== null && endDay !== null) {
            start = new Date(startYear, startMonth - 1, startDay, 0, 0, 0, 0);
            end = new Date(endYear, endMonth - 1, endDay, 23, 59, 59, 999);
        } else {
            start = new Date(year, month - 1, 1, 0, 0, 0, 0);
            end = new Date(year, month, 0, 23, 59, 59, 999);
        }

        start.setMinutes(start.getMinutes() - start.getTimezoneOffset());
        end.setMinutes(end.getMinutes() - end.getTimezoneOffset());

        start = start.toISOString();
        end = end.toISOString();

        return { start, end };
    };

    const exportMovementsToCSV = async () => {
        try {
            setLoadingCsv(true);
            const params = new URLSearchParams();

            const { start, end } = getStartAndEndDates();
            params.append("start_date", start);
            params.append("end_date", end);

            const decode_user_id = atob(user).split(":")[1];

            if (user !== null && user !== "all")
                params.append("user_id", decode_user_id);

            const url = `${API_URL}/reports/credits/movements/csv/?${params}`;

            const data = await storage.getItem("data");

            const options = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: data.token,
                },
            };

            if (impersonateCompanyId) {
                options.headers.Impersonate = impersonateCompanyId;
            }

            const response = await fetch(url, options);

            if (!response.ok) {
                if (response.status === 400) {
                    const errorMessage = await response.text();
                    throw new Error(errorMessage);
                }

                throw new Error(
                    "Erro ao gerar CSV. \nTente novamente mais tarde."
                );
            }

            const blob = await response.blob();
            const fileURL = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = fileURL;
            a.download = `zag_movimentos_creditos_${start.substring(
                0,
                10
            )}_${end.substring(0, 10)}.csv`;
            a.click();
            window.URL.revokeObjectURL(fileURL);
            setLoadingCsv(false);
        } catch (error) {
            showErrorModal(
                error.message ||
                    "Não foi possível gerar o CSV. \nTente novamente mais tarde."
            );
            setLoadingCsv(false);
        }
    };

    const exportMovementsToPDF = async () => {
        try {
            setLoadingPdf(true);
            const params = new URLSearchParams();

            const { start, end } = getStartAndEndDates();
            params.append("start_date", start);
            params.append("end_date", end);

            const decode_user_id = atob(user).split(":")[1];

            if (user !== null && user !== "all")
                params.append("user_id", decode_user_id);

            const url = `${API_URL}/reports/credits/movements/pdf/?${params}`;
            const data = await storage.getItem("data");

            const options = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: data.token,
                },
            };

            if (impersonateCompanyId) {
                options.headers.Impersonate = impersonateCompanyId;
            }

            const response = await fetch(url, options);

            if (!response.ok) {
                if (response.status === 400) {
                    const errorMessage = await response.text();
                    throw new Error(errorMessage);
                }

                throw new Error(
                    "Erro ao gerar PDF. \nTente novamente mais tarde."
                );
            }

            const blob = await response.blob();
            const fileURL = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = fileURL;
            a.download = `zag_movimentos_creditos_${start.substring(
                0,
                10
            )}_${end.substring(0, 10)}.pdf`;
            a.click();
            window.URL.revokeObjectURL(fileURL);
            setLoadingPdf(false);
        } catch (error) {
            showErrorModal(
                error.message ||
                    "Não foi possível gerar o PDF. \nTente novamente mais tarde."
            );
            setLoadingPdf(false);
        }
    };

    const [loading, setLoading] = useState(false);

    const RenderUser = (params) => {
        return (
            <>
                {params.row.name}{" "}
                {params.row.disabled && (
                    <>
                        (
                        <div style={{ textDecorationLine: "line-through" }}>
                            inativo
                        </div>
                        )
                    </>
                )}
            </>
        );
    };

    const columnsUsers = [
        { field: "id", headerName: "ID", width: 100 },
        {
            field: "name",
            headerName: "Nome",
            width: 300,
            renderCell: RenderUser,
        },
        { field: "credit", headerName: "Créditos", width: 300 },
    ];

    const RenderCredit = ({ value, refund }) => {
        const isRefund = refund && refund.startsWith("#");

        return (
            <strong
                style={{
                    color: value < 0 || isRefund ? "#DE6061" : "#57C4C2",
                }}
            >
                {isRefund
                    ? `-${helper.floatToMoney(Math.abs(value))}`
                    : helper.floatToMoney(value)}
            </strong>
        );
    };

    const RenderTextRefund = ({ value }) => {
        if (value === "CRÉDITO ADICIONADO" || value === "CRÉDITO DEVOLVIDO") {
            return (
                <strong
                    style={{
                        color:
                            value === "CRÉDITO ADICIONADO"
                                ? "#57C4C2"
                                : "#DE6061",
                        fontSize: 12,
                    }}
                >
                    {value}
                </strong>
            );
        }

        return <span style={{ fontSize: 13 }}>{value}</span>;
    };

    const columnsOperations = [
        { field: "id", headerName: "ID", width: 100 },
        { field: "name", headerName: "Nome", width: 150 },
        {
            field: "refund",
            headerName: "Reembolso",
            width: 200,
            renderCell: (params) => <RenderTextRefund value={params.value} />,
        },
        { field: "created", headerName: "Data", width: 130 },
        {
            field: "credit",
            headerName: "Transação",
            width: 100,
            renderCell: (params) => (
                <RenderCredit value={params.value} refund={params.row.refund} />
            ),
        },
    ];

    const [users, setUsers] = useState([]);
    // const [operations, setOperations] = useState([]);
    const [totalCredits, setTotalCredits] = useState("R$ 0,00");
    const [user, setUser] = useState("all");
    const [loadingCredits, setLoadingCredits] = useState();

    const [pageState, setPageState] = useState({
        isLoading: false,
        data: [],
        total: 0,
        page: 1,
        pageSize: 25,
        hasNextPage: true,
    });

    const getOperations = async (_user) => {
        try {
            const data = await storage.getItem("data");
            if (!data) return;

            const afterCursor = pageState.page > 1 ? pageState.endCursor : null;
            setLoadingCredits(true);

            const userId =
                _user === "all" ? null : parseInt(atob(_user).split(":")[1]);

            const responseRaw = await api.getCredits(
                data.token,
                year,
                month,
                startDay,
                endDay,
                startMonth,
                endMonth,
                startYear,
                endYear,
                impersonateCompanyId,
                afterCursor,
                pageState.pageSize,
                userId
            );

            const response = responseRaw?.data?.allCreditOperations;
            const _rows = [];

            for (let index = 0; index < response?.edges?.length; index++) {
                const operation = response.edges[index].node;

                _rows.push({
                    id: parseInt(atob(operation.id).split(":")[1]),
                    name: operation.userName,
                    refund: operation.refundId
                        ? `#${operation.refundId}`
                        : operation.value > 0
                        ? "CRÉDITO ADICIONADO"
                        : "CRÉDITO DEVOLVIDO",
                    created: helper.dateFromString(operation.createdAt),
                    credit: parseFloat(operation.value),
                });
            }

            setLoadingCredits(false);
            setPageState((old) => ({
                ...old,
                isLoading: false,
                data: _rows,
                total: response?.totalCount,
                endCursor: response?.pageInfo?.endCursor,
                hasNextPage: response?.pageInfo?.hasNextPage,
            }));
        } catch (error) {
            setLoadingCredits(false);
            showErrorModal(
                "Não foi possível aplicar os filtros. Verifique os dados e tente novamente."
            );
        }
    };

    const getUsers = async () => {
        setLoading(true);
        try {
            const data = await storage.getItem("data");
            if (!data) return;
            let response = await api.getUsersCredit(
                data.token,
                impersonateCompanyId
            );
            response = response.data.allZagviewUsers.edges;
            let _rows = [];
            let _users = [];
            let _totalCredits = 0;
            for (let index = 0; index < response.length; index++) {
                const user = response[index].node;
                _users.push({
                    id: user.id,
                    name: user.name,
                    disabled: user.disabled,
                    credit: helper.floatToMoney(user.availableCredit),
                });
                if (parseFloat(user.availableCredit) > 0) {
                    _totalCredits =
                        _totalCredits + parseFloat(user.availableCredit);
                    const _user = {
                        id: parseInt(atob(user.id).split(":")[1]),
                        name: user.name,
                        disabled: user.disabled,
                        credit: helper.floatToMoney(user.availableCredit),
                    };
                    _rows.push(_user);
                }
            }
            setTotalCredits(helper.floatToMoney(_totalCredits));
            setUsers(_users);
            setUsersRows(_rows);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            showErrorModal(
                "Não foi possível aplicar os filtros. Verifique os dados e tente novamente."
            );
        }
    };

    useEffect(() => {
        getOperations(user);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    useEffect(() => {
        if (user === "all") {
            getOperations(user);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageState.page, pageState.pageSize]);

    useEffect(() => {
        getUsers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function CustomExportMenu() {
        const [anchorEl, setAnchorEl] = useState(null);
        const open = Boolean(anchorEl);
        const handleClick = (event) => {
            setAnchorEl(event.currentTarget);
        };
        const handleClose = () => {
            setAnchorEl(null);
        };

        return (
            <GridToolbarContainer>
                <Button
                    startIcon={<DownloadIcon />}
                    onClick={handleClick}
                    size="small"
                >
                    Exportar
                </Button>
                <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                    <MenuItem
                        onClick={() => {
                            exportToCSV();
                            handleClose();
                        }}
                    >
                        <DownloadIcon
                            fontSize="small"
                            style={{ marginRight: 8 }}
                        />
                        Exportar como CSV
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            exportToPDF();
                            handleClose();
                        }}
                    >
                        <DownloadIcon
                            fontSize="small"
                            style={{ marginRight: 8 }}
                        />
                        Exportar como PDF
                    </MenuItem>
                </Menu>
            </GridToolbarContainer>
        );
    }

    const [width, setWidth] = useState(window.innerWidth);
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener("resize", handleWindowSizeChange);
        window.addEventListener("load", handleWindowSizeChange);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const customFooter = () => {
        return (
            <Box sx={{ p: 1, display: "flex" }}>
                <div
                    style={{ textAlign: "right", width: "100%", fontSize: 20 }}
                >
                    Total:&nbsp;<strong>{totalCredits}</strong>
                </div>
            </Box>
        );
    };

    const defaultMaskOptions = {
        prefix: "R$ ",
        suffix: "",
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: "",
        allowDecimal: true,
        decimalSymbol: ",",
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 7, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
    };

    const currencyMask = createNumberMask({
        ...defaultMaskOptions,
    });

    const [credit, setCredit] = useState(0);

    const sendCredit = async (type) => {
        if (credit !== 0) {
            setLoading(true);
            let _credit = type === "decrease" ? credit * -1 : credit;
            try {
                const data = await storage.getItem("data");
                await api.sendCredit(
                    data.token,
                    parseInt(atob(user).split(":")[1]),
                    _credit,
                    impersonateCompanyId
                );
                setLoading(false);
                getUsers();
                getOperations(user);
            } catch (error) {
                setLoading(false);
                if (type === "decrease") {
                    showErrorModal(
                        "Não foi possível diminuir os créditos. Tente novamente."
                    );
                } else {
                    showErrorModal(
                        "Não foi possível adicionar os créditos. Tente novamente."
                    );
                }
            }
        }
    };

    const currentYear = new Date().getFullYear();
    const firstYear = 2016;

    const years = Array.from(
        { length: currentYear - firstYear + 1 },
        (_, i) => currentYear - i
    );

    const [openFilterDay, setOpenFilterDay] = useState(false);
    const [startDay, setStartDay] = useState(null);
    const [startMonth, setStartMonth] = useState(null);
    const [startYear, setStartYear] = useState(null);
    const [endDay, setEndDay] = useState(null);
    const [endMonth, setEndMonth] = useState(null);
    const [endYear, setEndYear] = useState(null);
    const [errorMessageDate, setErrorMessageDate] = useState(false);
    const [applyFilters, setApplyFilters] = useState(false);
    const [filtersApplied, setFiltersApplied] = useState(false);
    const [year, setYear] = useState(currentYear);
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [openAlert, setOpenAlert] = useState(false);
    const [loadingCsv, setLoadingCsv] = useState(false);
    const [loadingPdf, setLoadingPdf] = useState(false);

    const handleFilterDayOpen = () => setOpenFilterDay(true);

    const handleFilterDayClose = () => {
        setOpenFilterDay(false);
        setStartDay(null);
        setEndDay(null);
        setStartMonth(null);
        setEndMonth(null);
        setStartYear(null);
        setEndYear(null);
        setErrorMessageDate(false);
    };

    const handleStartDateChange = (event) => {
        const [year, month, day] = event.target.value.split("-");

        if (year && month && day) {
            setStartYear(year);
            setStartMonth(month);
            setStartDay(day);
        }
    };

    const handleEndDateChange = (event) => {
        const [year, month, day] = event.target.value.split("-");

        if (year && month && day) {
            setEndYear(year);
            setEndMonth(month);
            setEndDay(day);
        }
    };

    const handleConfirmFilterDate = () => {
        if (!startYear || !startMonth || !startDay) {
            setErrorMessageDate(
                "Por favor, preencha pelo menos a data inicial."
            );
            return;
        }

        let finalYear = endYear || startYear;
        let finalMonth = endMonth || startMonth;
        let finalDay = endDay || startDay;

        const startDate = new Date(`${startYear}-${startMonth}-${startDay}`);
        const endDate = new Date(`${finalYear}-${finalMonth}-${finalDay}`);

        if (endDate < startDate) {
            setErrorMessageDate(
                "A data final não pode ser anterior à data inicial."
            );
            return;
        }

        setErrorMessageDate("");

        setStartDay(startDay);
        setEndDay(finalDay);
        setStartMonth(startMonth);
        setEndMonth(finalMonth);
        setStartYear(startYear);
        setEndYear(finalYear);
        setOpenFilterDay(false);

        setFiltersApplied(true);
        setApplyFilters(true);
    };

    const handleDeleteDate = () => {
        setStartDay(null);
        setStartMonth(null);
        setStartYear(null);
        setEndDay(null);
        setEndMonth(null);
        setEndYear(null);
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            handleConfirmFilterDate();
        }
    };

    useEffect(() => {
        if (applyFilters) {
            getOperations(user);
            setApplyFilters(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        applyFilters,
        year,
        month,
        startDay,
        endDay,
        startMonth,
        endMonth,
        startYear,
        endYear,
    ]);

    function toolbarDatagridAllOperations() {
        return (
            <GridToolbarContainer>
                <Button
                    type="button"
                    aria-label="Gerar PDF"
                    onClick={exportMovementsToPDF}
                    disabled={loadingPdf}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        background: "none",
                        border: "none",
                        cursor: loadingPdf ? "not-allowed" : "pointer",
                        fontWeight: 500,
                        fontSize: "0.8125rem",
                        lineHeight: 1.75,
                        letterSpacing: "0.02857em",
                        textTransform: "uppercase",
                        minWidth: 64,
                        padding: "4px 5px",
                        borderRadius: 4,
                        transition:
                            "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1), border-color 250ms, color 250ms",
                        color: "#57C4C2",
                    }}
                >
                    {loadingPdf ? (
                        <>
                            <CircularProgress
                                size={16}
                                style={{ marginRight: 8 }}
                            />
                        </>
                    ) : (
                        <>
                            <span
                                style={{
                                    width: 18,
                                    height: 18,
                                    margin: "0px 6px",
                                    float: "left",
                                }}
                            >
                                <svg
                                    viewBox="0 0 24 24"
                                    style={{ width: 18, height: 18 }}
                                >
                                    <path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"></path>
                                </svg>
                            </span>
                            Gerar PDF
                        </>
                    )}
                </Button>
                <Button
                    type="button"
                    aria-label="Baixar Relatório CSV"
                    onClick={exportMovementsToCSV}
                    disabled={loadingCsv}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        background: "none",
                        border: "none",
                        cursor: loadingCsv ? "not-allowed" : "pointer",
                        fontWeight: 500,
                        fontSize: "0.8125rem",
                        lineHeight: 1.75,
                        letterSpacing: "0.02857em",
                        textTransform: "uppercase",
                        minWidth: 64,
                        padding: "4px 5px",
                        borderRadius: 4,
                        transition:
                            "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1), border-color 250ms, color 250ms",
                        color: loadingCsv ? "#999" : "#57C4C2",
                    }}
                >
                    {loadingCsv ? (
                        <>
                            <CircularProgress
                                size={16}
                                style={{ marginRight: 8 }}
                            />
                        </>
                    ) : (
                        <>
                            <span
                                style={{
                                    width: 18,
                                    height: 18,
                                    margin: "0px 6px",
                                    float: "left",
                                }}
                            >
                                <svg
                                    viewBox="0 0 24 24"
                                    style={{ width: 18, height: 18 }}
                                >
                                    <path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"></path>
                                </svg>
                            </span>
                            EXPORTAR CSV
                        </>
                    )}
                </Button>
            </GridToolbarContainer>
        );
    }

    return (
        <>
            <Modal
                open={openAlert}
                onClose={() => {
                    setOpenAlert(false);
                }}
                aria-labelledby="export-limit-modal-title"
                aria-describedby="export-limit-modal-description"
            >
                <ModalRejector style={{ height: "auto", padding: "20px" }}>
                    <ModalClose
                        src="/img/modal_close.svg"
                        onClick={() => {
                            setOpenAlert(false);
                        }}
                    />

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            marginBottom: 16,
                        }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                        >
                            <path
                                d="M12.5 8.00002V12M12.5 16H12.51M3.5 7.94147V16.0586C3.5 16.4012 3.5 16.5725 3.55048 16.7253C3.59515 16.8605 3.66816 16.9846 3.76463 17.0893C3.87369 17.2076 4.02345 17.2908 4.32297 17.4572L11.723 21.5683C12.0066 21.7259 12.1484 21.8047 12.2985 21.8356C12.4315 21.8629 12.5685 21.8629 12.7015 21.8356C12.8516 21.8047 12.9934 21.7259 13.277 21.5683L20.677 17.4572C20.9766 17.2908 21.1263 17.2076 21.2354 17.0893C21.3318 16.9846 21.4049 16.8605 21.4495 16.7253C21.5 16.5725 21.5 16.4012 21.5 16.0586V7.94147C21.5 7.59883 21.5 7.4275 21.4495 7.27471C21.4049 7.13953 21.3318 7.01545 21.2354 6.91076C21.1263 6.79242 20.9766 6.70922 20.677 6.54282L13.277 2.43171C12.9934 2.27415 12.8516 2.19537 12.7015 2.16448C12.5685 2.13715 12.4315 2.13715 12.2985 2.16448C12.1484 2.19537 12.0066 2.27415 11.723 2.43171L4.32297 6.54282C4.02345 6.70922 3.87369 6.79242 3.76463 6.91076C3.66816 7.01545 3.59515 7.13953 3.55048 7.27471C3.5 7.4275 3.5 7.59883 3.5 7.94147Z"
                                stroke="#CA1C1C"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </div>

                    <BasicTitle
                        title={"NÃO FOI POSSÍVEL EXPORTAR"}
                        showLine={false}
                        center
                    />

                    <div style={{ textAlign: "center", margin: "20px 0" }}>
                        <p
                            style={{
                                fontSize: "16px",
                                marginBottom: "30px",
                                color: "#181122",
                                fontWeight: "300",
                                lineHeight: "25px",
                            }}
                        >
                            O arquivo exportado é muito grande. Selecione um
                            período de tempo menor e tente novamente.{" "}
                        </p>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                setOpenAlert(false);
                            }}
                            style={{
                                marginBottom: "10px",
                                width: "100%",
                                height: "3rem",
                                color: "#000",
                                fontWeight: "600",
                            }}
                        >
                            OK, ENTENDI
                        </Button>
                    </div>
                </ModalRejector>
            </Modal>
            {/* <Modal
                open={openAlert}
                onClose={() => {
                    setOpenAlert(false);
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <ModalAlert>
                    <ModalClose
                        src="/img/modal_close.svg"
                        onClick={() => {
                            setOpenAlert(false);
                        }}
                    />
                        <div style={{padding: 24}}>
                        <BasicTitle title={"Não foi possível exportar"} />
                        <TextModal style={{marginTop: 24, textTransform: "uppercase"}}>
                            O arquivo exportado é muito grande. Selecione um período de tempo menor e tente novamente.
                        </TextModal>
                        </div>
                        <div style={{borderTop: "1px solid #E6E6E6"}}>
                            <Button
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    margin: "0 auto",
                                    marginTop: 24,
                                    marginBottom: 24
                                }}
                                variant="contained"
                                disableelevation="true"
                                color="primary"
                                onClick={() => {
                                    setOpenAlert(false);
                                }}
                            >
                                OK, ENTENDI
                            </Button>
                        </div>
                </ModalAlert>
            </Modal> */}
            <Modal
                open={openFilterDay}
                onClose={handleFilterDayClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <ModalCenter
                    style={{
                        overflowY: "auto",
                        maxHeight: "95%",
                        width: 550,
                        height: "auto",
                        padding: 30,
                    }}
                >
                    <ModalClose
                        src="/img/modal_close.svg"
                        onClick={handleFilterDayClose}
                        style={{ top: 30, right: 30 }}
                    />
                    <BasicTitle title={"Período"} />
                    <div
                        style={{
                            width: "100%",
                            marginBottom: 24,
                            marginTop: 24,
                            display: "flex",
                            justifyContent: "row",
                        }}
                    >
                        <FormControl style={{ marginRight: 24 }}>
                            <TextField
                                label="Data Inicial"
                                type="date"
                                style={{ width: 180 }}
                                value={`${startYear || ""}-${(
                                    startMonth || ""
                                ).padStart(2, "0")}-${(startDay || "").padStart(
                                    2,
                                    "0"
                                )}`}
                                onChange={handleStartDateChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </FormControl>

                        <FormControl>
                            <TextField
                                label="Data Final"
                                type="date"
                                style={{ width: 200 }}
                                value={`${endYear || ""}-${(
                                    endMonth || ""
                                ).padStart(2, "0")}-${(endDay || "").padStart(
                                    2,
                                    "0"
                                )}`}
                                onChange={handleEndDateChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onKeyDown={handleKeyDown}
                            />
                        </FormControl>
                        <button
                            style={{ background: "none", border: "none" }}
                            onClick={() => {
                                handleConfirmFilterDate();
                            }}
                        >
                            <img
                                src="/img/confirm.svg"
                                alt=""
                                style={{
                                    width: 57,
                                    height: 57,
                                    cursor: "pointer",
                                    marginLeft: 16,
                                }}
                            />
                        </button>
                    </div>
                    {errorMessageDate && (
                        <ErrorMessage>{errorMessageDate}</ErrorMessage>
                    )}
                </ModalCenter>
            </Modal>
            {loading && <Loader />}
            <Holder>
                <Content title={"Créditos"}>
                    <Filters
                        style={{ display: width < 1000 ? "block" : "flex" }}
                    >
                        <LeftFilters
                            style={{ marginBottom: width < 1000 ? 16 : 0 }}
                        >
                            <FormControl
                                style={{
                                    width: width < 1000 ? "100%" : 450,
                                    marginRight: 16,
                                }}
                                size="medium"
                            >
                                <Autocomplete
                                    options={users}
                                    defaultValue={user}
                                    getOptionLabel={(option) => {
                                        if (typeof option === "string")
                                            return option;
                                        return `${option.name}${
                                            option.disabled ? " (inativo)" : ""
                                        } ${option.credit ?? ""}`;
                                    }}
                                    isOptionEqualToValue={(option, value) =>
                                        option?.id === value?.id
                                    }
                                    value={
                                        users.find((u) => u.id === user) || null
                                    }
                                    onChange={(event, newValue) => {
                                        const selectedId =
                                            newValue?.id ?? "all";
                                        setUser(selectedId);
                                        getOperations(selectedId);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Usuários"
                                            size="medium"
                                            placeholder="Selecione um usuário"
                                        />
                                    )}
                                    renderOption={(props, option) => (
                                        <li {...props} key={option.id}>
                                            {option.name}
                                            {option.disabled
                                                ? " (inativo)"
                                                : ""}{" "}
                                            {option.credit ?? ""}
                                        </li>
                                    )}
                                    clearOnEscape
                                    sx={{
                                        width: width < 1000 ? "100%" : 450,
                                        marginRight: 2,
                                        backgroundColor: "#fafafa",
                                    }}
                                />
                                {/* <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    defaultValue={user}
                                    label="Status"
                                    onChange={(event) => {
                                        setUser(event.target.value);
                                        getOperations(event.target.value);
                                    }}
                                >
                                    <MenuItem value={"all"} >Todos</MenuItem>
                                    {users
                                        .sort((a, b) =>
                                            a.name.localeCompare(b.name)
                                        )
                                        .map((user) => (
                                            <MenuItem
                                                key={user.id}
                                                value={user.id}
                                            >
                                                {user.name} {user.disabled && <>(<div style={{textDecorationLine: 'line-through'}}>inativo</div>)</>} {user.credit}
                                            </MenuItem>
                                        ))}
                                </Select> */}
                            </FormControl>
                        </LeftFilters>
                    </Filters>
                    {user === "all" && (
                        <Data style={{ marginBottom: 100 }}>
                            <DataGrid
                                rows={usersRows}
                                columns={columnsUsers}
                                initialState={{
                                    pagination: {
                                        paginationModel: { pageSize: 20 },
                                    },
                                }}
                                // onCellClick={(
                                //   params: GridCellParams,
                                //   event: MuiEvent<React.MouseEvent>
                                // ) => {
                                //   event.defaultMuiPrevented = true;
                                // }}
                                pageSizeOptions={[
                                    4,
                                    4 * 4,
                                    4 * 4 * 4,
                                    4 * 4 * 4 * 4,
                                ]}
                                //   checkboxSelection
                                disableRowSelectionOnClick
                                //   onRowSelectionModelChange={handleChangeCellSelection}
                                slots={{
                                    toolbar: () => (
                                        <CustomExportMenu
                                            usersRows={usersRows}
                                            columnsUsers={columnsUsers}
                                        />
                                    ),
                                    footer: customFooter,
                                }}
                            />
                        </Data>
                    )}
                    {user !== "all" && (
                        <FormControl
                            style={{
                                width: width < 1000 ? "100%" : 450,
                                marginRight: 16,
                            }}
                            size="small"
                        >
                            <AddCredit>
                                <MaskedInput
                                    mask={currencyMask}
                                    placeholder="R$ 0,00"
                                    style={{
                                        fontSize: 16,
                                        padding: 14,
                                        border: "1px solid #181122",
                                        borderRadius: 8,
                                        marginRight: 16,
                                        width: 200,
                                        fontWeight: "bold",
                                    }}
                                    onChange={(event) => {
                                        let _value = event.target.value;
                                        if (_value) {
                                            _value = _value.replace("R$ ", "");
                                            _value = parseFloat(
                                                _value.replace(",", ".")
                                            );
                                            setCredit(_value);
                                        }
                                    }}
                                />
                                {impersonateCompanyId === null ? (
                                    <>
                                        <Button
                                            style={{
                                                // width: "100%",
                                                // maxWidth: 327,
                                                fontWeight: 700,
                                                fontSize: 20,
                                                padding: "10px 12px",
                                                marginRight: 16,
                                            }}
                                            variant="contained"
                                            disableelevation="true"
                                            color="error"
                                            onChange={(event) => {
                                                setCredit(event.target.value);
                                            }}
                                            onClick={() => {
                                                sendCredit("decrease");
                                            }}
                                        >
                                            -
                                        </Button>
                                        <Button
                                            style={{
                                                // width: "100%",
                                                // maxWidth: 327,
                                                fontWeight: 700,
                                                fontSize: 20,
                                                padding: "10px 12px",
                                                color: "#ffffff",
                                                marginRight: 16,
                                            }}
                                            variant="contained"
                                            disableelevation="true"
                                            color="primary"
                                            onChange={(event) => {
                                                setCredit(event.target.value);
                                            }}
                                            onClick={() => {
                                                sendCredit("increase");
                                            }}
                                        >
                                            +
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <Button
                                            style={{
                                                fontWeight: 700,
                                                fontSize: 20,
                                                padding: "10px 12px",
                                                marginRight: 16,
                                                color: "#d3d3d3",
                                            }}
                                            variant="outlined"
                                            disableelevation="true"
                                            color="primary"
                                        >
                                            -
                                        </Button>
                                        <Button
                                            style={{
                                                fontWeight: 700,
                                                fontSize: 20,
                                                padding: "10px 12px",
                                                marginRight: 16,
                                                color: "#d3d3d3",
                                            }}
                                            variant="outlined"
                                            disableelevation="true"
                                            color="primary"
                                        >
                                            +
                                        </Button>
                                    </>
                                )}
                            </AddCredit>
                        </FormControl>
                    )}
                    {loadingCredits && !loading ? (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "500px",
                            }}
                        >
                            <CircularProgress size="40px" />
                        </div>
                    ) : (
                        <>
                            <BasicTitle title={"MOVIMENTAÇÕES"} />
                            <div
                                style={{
                                    marginTop: 24,
                                    marginBottom: 24,
                                }}
                            >
                                <FormControl
                                    style={{
                                        width: width < 1000 ? "100%" : 110,
                                        marginRight: 16,
                                    }}
                                    size="small"
                                    disabled={startDay !== null}
                                >
                                    <InputLabel>Ano</InputLabel>
                                    <Select
                                        label="Ano"
                                        value={year}
                                        onChange={(event) => {
                                            setYear(Number(event.target.value));
                                            setTimeout(
                                                () => setApplyFilters(true),
                                                300
                                            );
                                        }}
                                        disabled={pageState.isLoading}
                                    >
                                        {years.map((y) => (
                                            <MenuItem key={y} value={y}>
                                                {y}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl
                                    style={{
                                        width: width < 1000 ? "100%" : 160,
                                    }}
                                    size="small"
                                    disabled={startDay !== null}
                                >
                                    <InputLabel>Mês</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        defaultValue={month}
                                        label="Mês"
                                        onChange={(event) => {
                                            setMonth(event.target.value);
                                            setApplyFilters(true);
                                        }}
                                        disabled={pageState.isLoading}
                                    >
                                        <MenuItem value={1}>Janeiro</MenuItem>
                                        <MenuItem value={2}>Fevereiro</MenuItem>
                                        <MenuItem value={3}>Março</MenuItem>
                                        <MenuItem value={4}>Abril</MenuItem>
                                        <MenuItem value={5}>Maio</MenuItem>
                                        <MenuItem value={6}>Junho</MenuItem>
                                        <MenuItem value={7}>Julho</MenuItem>
                                        <MenuItem value={8}>Agosto</MenuItem>
                                        <MenuItem value={9}>Setembro</MenuItem>
                                        <MenuItem value={10}>Outubro</MenuItem>
                                        <MenuItem value={11}>Novembro</MenuItem>
                                        <MenuItem value={12}>Dezembro</MenuItem>
                                    </Select>
                                </FormControl>
                                <button
                                    style={{
                                        marginLeft: 16,
                                        background: "none",
                                        border: "none",
                                        cursor: "pointer",
                                    }}
                                    variant="contained"
                                    disableelevation="true"
                                    onClick={handleFilterDayOpen}
                                    disabled={pageState.isLoading}
                                >
                                    <img
                                        src="/img/calendar.svg"
                                        alt=""
                                        style={{
                                            width: 40,
                                            height: 40,
                                        }}
                                    />
                                </button>
                            </div>
                            {filtersApplied && startDay !== null && (
                                <>
                                    <BasicTitle title={"Filtros Ativos"} />
                                    <Stack
                                        direction="row"
                                        spacing={1}
                                        sx={{ marginBottom: 3 }}
                                    >
                                        {startDay !== null && (
                                            <Chip
                                                label={`${startDay}/${startMonth}/${startYear} - ${
                                                    endDay ? endDay : "--"
                                                }/${
                                                    endMonth ? endMonth : "--"
                                                }/${
                                                    endYear ? endYear : "----"
                                                }`}
                                                onDelete={() => {
                                                    handleDeleteDate();
                                                    setTimeout(() => {
                                                        setApplyFilters(true);
                                                    }, 300);
                                                }}
                                            />
                                        )}
                                        <Button
                                            style={{
                                                fontWeight: 700,
                                                fontSize: 12,
                                                padding: "6px 12px",
                                            }}
                                            disableElevation
                                            color="error"
                                            onClick={() => {
                                                setStartDay(null);
                                                setStartMonth(null);
                                                setStartYear(null);
                                                setEndDay(null);
                                                setEndMonth(null);
                                                setEndYear(null);
                                                setTimeout(() => {
                                                    setApplyFilters(true);
                                                    setFiltersApplied(false);
                                                }, 300);
                                            }}
                                        >
                                            LIMPAR SELEÇÃO
                                        </Button>
                                    </Stack>
                                </>
                            )}

                            <Data style={{ paddingBottom: 50 }}>
                                <DataGrid
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: pageState.pageSize,
                                            },
                                        },
                                    }}
                                    style={{ marginBottom: 100 }}
                                    autoHeight
                                    rows={pageState.data}
                                    rowCount={pageState.total}
                                    loading={pageState.isLoading}
                                    pageSizeOptions={[25, 50, 100]}
                                    pagination
                                    paginationModel={{
                                        page: pageState.page - 1,
                                        pageSize: pageState.pageSize,
                                    }}
                                    paginationMode="server"
                                    onPaginationModelChange={(model) => {
                                        const { page, pageSize } = model;
                                        setPageState((old) => ({
                                            ...old,
                                            page: page + 1,
                                            pageSize: pageSize,
                                        }));
                                    }}
                                    columns={columnsOperations}
                                    disableRowSelectionOnClick
                                    slots={{
                                        toolbar: toolbarDatagridAllOperations,
                                    }}
                                    componentsProps={{
                                        row: {
                                            style: { cursor: "pointer" },
                                        },
                                    }}
                                />
                            </Data>
                        </>
                    )}
                </Content>
                <ErrorModal
                    open={errorModalOpen}
                    onClose={() => setErrorModalOpen(false)}
                    message={errorModalMessage}
                />
            </Holder>
        </>
    );
}
